// extracted by mini-css-extract-plugin
export default {"ruleSelect":"preset_ruleSelect__aNcLW","label":"preset_label__h-DvK","contentTypeLabel":"preset_contentTypeLabel__nShHz"};